import React, { useState, FunctionComponent, useEffect } from 'react';
import { TextField, CircularProgress } from '@mui/material';
import { Send } from '@mui/icons-material';
import i18next from 'i18next';

import { ViewContainer, ViewContent } from 'styles/view';
import { IContactViewProps, IContactFormData } from './types';
import { FormWrapper, StyledPaper, Title, SubmitButton } from './styles';

const ContactView: FunctionComponent<IContactViewProps> = ({ onSendEmail, loading, success }) => {
  const [formData, setFormData] = useState<IContactFormData>({ subject: '', message: '' });

  useEffect(() => {
    if (success) {
      setFormData({ subject: '', message: '' });
    }
  }, [success]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSendEmail(formData.subject, formData.message);
  };

  const handleChange =
    (field: keyof IContactFormData) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setFormData((prev) => ({ ...prev, [field]: e.target.value }));
    };

  return (
    <ViewContainer auth>
      <ViewContent auth>
        <FormWrapper>
          <StyledPaper elevation={3}>
            <Title variant="h5" align="center">
              {i18next.t<String>('CONTACT:TITLE', 'Nueva Consulta')}
            </Title>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label={i18next.t<String>('CONTACT:SUBJECT', 'Asunto')}
                margin="normal"
                required
                value={formData.subject}
                onChange={handleChange('subject')}
                disabled={loading}
              />
              <TextField
                fullWidth
                label={i18next.t<String>('CONTACT:MESSAGE', 'Mensaje')}
                margin="normal"
                multiline
                rows={5}
                required
                value={formData.message}
                onChange={handleChange('message')}
                disabled={loading}
              />
              <SubmitButton
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Send />}
              >
                {loading
                  ? i18next.t<String>('CONTACT:SENDING', 'Enviando...')
                  : i18next.t<String>('CONTACT:SEND_BUTTON', 'Enviar Consulta')}
              </SubmitButton>
            </form>
          </StyledPaper>
        </FormWrapper>
      </ViewContent>
    </ViewContainer>
  );
};

export default ContactView;
